import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

export default function SignalsPanel({ summary, journal }) {
  const chartData = journal
    ?.filter(t => t.status === "closed")
    .slice()
    .sort((a, b) => new Date(a.opened_at) - new Date(b.opened_at))
    .map((t, i) => ({
      name: `#${i + 1}`,
      pnl: t.pnl,
      rr: t.actual_rr
    })) || [];

  const statBox = (label, value, color = "#e0e0e0") => (
    <div style={stat}>
      <span style={statVal(color)}>{value ?? "—"}</span>
      <span style={statLbl}>{label}</span>
    </div>
  );

  return (
    <div style={card}>
      <h2 style={heading}>Performance Summary</h2>

      <div style={statsRow}>
        {statBox("Total Trades", summary?.total_trades)}
        {statBox("Win Rate", summary?.win_rate, "#1D9E75")}
        {statBox("Total PnL", summary?.total_pnl !== undefined ? `$${summary.total_pnl}` : "—",
          summary?.total_pnl >= 0 ? "#1D9E75" : "#e24b4a")}
        {statBox("Avg RR", summary?.avg_actual_rr)}
      </div>

      {chartData.length > 0 && (
        <>
          <p style={chartLabel}>PnL per trade</p>
          <ResponsiveContainer width="100%" height={120}>
            <LineChart data={chartData}>
              <XAxis dataKey="name" stroke="#444" tick={{ fontSize: 11 }} />
              <YAxis stroke="#444" tick={{ fontSize: 11 }} />
              <Tooltip
                contentStyle={{ background: "#1a1a1a", border: "1px solid #333" }}
                labelStyle={{ color: "#888" }}
              />
              <Line
                type="monotone"
                dataKey="pnl"
                stroke="#1D9E75"
                strokeWidth={2}
                dot={{ fill: "#1D9E75", r: 3 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </>
      )}

      {chartData.length === 0 && (
        <p style={empty}>No closed trades yet — PnL chart will appear here</p>
      )}
    </div>
  );
}

const card = {
  background: "#1a1a1a",
  borderRadius: "12px",
  padding: "20px",
  border: "1px solid #2a2a2a"
};
const heading = {
  margin: "0 0 16px",
  fontSize: "14px",
  fontWeight: "600",
  color: "#ffffff",
  textTransform: "uppercase",
  letterSpacing: "0.5px"
};
const statsRow = {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "8px",
  marginBottom: "16px"
};
const stat = {
  background: "#222",
  borderRadius: "8px",
  padding: "12px 8px",
  textAlign: "center"
};
const statVal = (color) => ({
  display: "block",
  fontSize: "18px",
  fontWeight: "700",
  color
});
const statLbl = {
  display: "block",
  fontSize: "11px",
  color: "#666",
  marginTop: "4px"
};
const chartLabel = {
  fontSize: "12px",
  color: "#666",
  margin: "0 0 8px"
};
const empty = {
  color: "#555",
  fontSize: "13px",
  textAlign: "center",
  padding: "20px 0"
};